<template>
  <div
    v-if="showWebinarRegistrationButton"
    class="material__register"
  >
    <button
      :class="[
        'material__register--btn',
        {'material__register--btn-disabled': haveUser}
      ]"
      @click="$emit('openWebinarRegModal')"
    >
      {{ haveUser ? 'вы зарегистрированы' : 'зарегистрироваться' }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'WebinarRegister',
  props: {
    webinar: { type: Object, required: true },
    haveUser: { type: Boolean, default: false },
  },
  data: () => ({
    now: new Date(),
    interval: null,
  }),
  computed: {
    showWebinarRegistrationButton() {
      return this.webinar?.id && !this.webinarHasEnded;
    },
    webinarHasEnded() {
      if (this.webinar?.id) {
        return this.now > new Date(this.webinar.endDate);
      }
      return false;
    },
  },
  mounted() {
    if (this.webinar?.id && !this.webinarHasEnded) {
      this.interval = setInterval(this.updateTime, 1000);
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped lang="scss">

.material__register {
  width: 100%;

  &--btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: calc(var(--scale) * 80);

    border: none;
    border-radius: calc(var(--scale) * 24);
    background-color: #FF5319;

    font-size: calc(var(--scale) * 18);
    font-weight: 500;
    line-height: 110%;
    letter-spacing: -0.02em;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: $white-color;

    cursor: pointer;
    transition: background-color .2s ease-out;

    &:hover {
      background-color: #FF9C12;
    }

    &-disabled {
      pointer-events: none;
      background-color: #ECEDF0;
      color: #A7ABAC;
    }

    @include media-down($size-tablet) {
      max-width: calc(var(--scale) * 350);
    }

    @include media-down($size-mobile) {
      max-width: 100%;
      margin-top: calc(var(--scale) * -22);
      margin-bottom: calc(var(--scale) * 32);
    }
  }
}

</style>
